<template>
    <div>
        <ul class="dropdowns">
            <DropDown 
                v-for="person in people" 
                :key="person.name" 
                :title="person.name"
                :content="null"
                :ad-img="null"
                :ad-url="null"
                :personBio="person.bio"
                :personRole="person.role"
                :personImg="person.picture"
                type="person-dropdown"
                class="dropdown--person"
            />
            <DropDown 
                v-for="dropdown in dropdowns" 
                :key="dropdown.title" 
                :title="dropdown.title"
                :content="dropdown.content"
                :ad-img="dropdown.ad"
                :ad-url="dropdown.adUrl"
                :personBio="null"
                :personRole="null"
                :personImg="null"
                type="regular-dropdown"
                class="dropdown--regular"
            />
        </ul>
    </div>
</template>
<script>
    import DropDown from './DropDown.vue';
    export default {
        props: [
            'people',
            'dropdowns'
        ],
        components: {
            DropDown
        }
    }
</script>
<style scoped>
    div {
        display: flex;
        justify-content: center;
        padding: 50px 30px;
    }

    /* ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    } */
    .dropdowns {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;
        max-width: 1200px;
        margin: 0 -20px;
        padding: 0;
        list-style: none;
    }
</style>
